module.exports = __webpack_public_path__ + "static/img/subway-landing.cbad274.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subway-landing.png
// module id = 151
// module chunks = 0